/* eslint-disable */
import dynamic from 'next/dynamic';


import GoogleTagManagerNoscript from '@magalu/mixer-modules/build/esm/novisual/GoogleTagManagerNoscript';
import ApssFlyerBanner from '@magalu/mixer-modules/build/esm/novisual/ApssFlyerBanner';
import AdsBanner from '@magalu/mixer-modules/build/esm/components/ecommerce/AdsBanner';
import ExternalContent from '@magalu/mixer-modules/build/esm/components/ecommerce/ExternalContent';
import Header from '@magalu/mixer-modules/build/esm/components/ecommerce/Header';
import MetaNoIndex from '@magalu/mixer-modules/build/esm/components/ecommerce/MetaNoIndex';
import SearchTitle from '@magalu/mixer-modules/build/esm/components/ecommerce/SearchTitle';
import ToolBar from '@magalu/mixer-modules/build/esm/components/ecommerce/ToolBar';
import Row from '@magalu/mixer-modules/build/esm/components/ecommerce/Row';
import AdsBrand from '@magalu/mixer-modules/build/esm/components/ecommerce/AdsBrand';
import FastFilters from '@magalu/mixer-modules/build/esm/components/ecommerce/FastFilters';
import Heading from '@magalu/mixer-modules/build/esm/components/ecommerce/Heading';
import DidYouMean from '@magalu/mixer-modules/build/esm/components/ecommerce/DidYouMean';
import ProductList from '@magalu/mixer-modules/build/esm/components/ecommerce/ProductList';
import Pagination from '@magalu/mixer-modules/build/esm/components/ecommerce/Pagination';
import DocumentSupportText from '@magalu/mixer-modules/build/esm/components/ecommerce/DocumentSupportText';
import SeoLinkList from '@magalu/mixer-modules/build/esm/components/ecommerce/SeoLinkList';
import TermList from '@magalu/mixer-modules/build/esm/components/ecommerce/TermList';
import Faq from '@magalu/mixer-modules/build/esm/components/ecommerce/Faq';
import Footer from '@magalu/mixer-modules/build/esm/components/ecommerce/Footer';
import Favicon from '@magalu/mixer-modules/build/esm/novisual/Favicon';
import Preconnect from '@magalu/mixer-modules/build/esm/novisual/Preconnect';
import Preload from '@magalu/mixer-modules/build/esm/novisual/Preload';
import Datadog from '@magalu/mixer-modules/build/esm/novisual/Datadog';
import GoogleTagManagerHead from '@magalu/mixer-modules/build/esm/novisual/GoogleTagManagerHead';
import Stewie from '@magalu/mixer-modules/build/esm/novisual/Stewie';
import AllIn from '@magalu/mixer-modules/build/esm/novisual/AllIn';
import Criteo from '@magalu/mixer-modules/build/esm/novisual/Criteo';
import TikTok from '@magalu/mixer-modules/build/esm/novisual/TikTok';
import SpotifyAdAnalytics from '@magalu/mixer-modules/build/esm/novisual/SpotifyAdAnalytics';
import Hotjar from '@magalu/mixer-modules/build/esm/novisual/Hotjar';
import RTBHouse from '@magalu/mixer-modules/build/esm/novisual/RTBHouse';
import Vwo from '@magalu/mixer-modules/build/esm/novisual/Vwo';
import Azion from '@magalu/mixer-modules/build/esm/novisual/Azion';
import Bing from '@magalu/mixer-modules/build/esm/novisual/Bing';

const pageModules = {
  GoogleTagManagerNoscript,
  ApssFlyerBanner,
  AdsBanner,
  ExternalContent,
  Header,
  MetaNoIndex,
  SearchTitle,
  ToolBar,
  Row,
  AdsBrand,
  FastFilters,
  Heading,
  DidYouMean,
  ProductList,
  Pagination,
  DocumentSupportText,
  SeoLinkList,
  TermList,
  Faq,
  Footer,
  Favicon,
  Preconnect,
  Preload,
  Datadog,
  GoogleTagManagerHead,
  Stewie,
  AllIn,
  Criteo,
  TikTok,
  SpotifyAdAnalytics,
  Hotjar,
  RTBHouse,
  Vwo,
  Azion,
  Bing,
  BackToTop: dynamic(() => import('@magalu/mixer-modules/build/esm/components/ecommerce/BackToTop'),
    { ssr: false }
  ),
  CloseableAdUnit: dynamic(() => import('@magalu/mixer-modules/build/esm/components/ecommerce/CloseableAdUnit'),
    { ssr: false }
  ),
  ZipCodeBar: dynamic(() => import('@magalu/mixer-modules/build/esm/components/ecommerce/ZipCodeBar'),
    { ssr: false }
  ),
  ZipCodeInput: dynamic(() => import('@magalu/mixer-modules/build/esm/components/ecommerce/ZipCodeInput'),
    { ssr: false }
  ),
  FilterDelivery: dynamic(() => import('@magalu/mixer-modules/build/esm/components/ecommerce/FilterDelivery'),
    { ssr: false }
  ),
  Showcase: dynamic(() => import('@magalu/mixer-modules/build/esm/components/ecommerce/Showcase'),
    { ssr: false }
  ),
  Loader: dynamic(() => import('@magalu/mixer-modules/build/esm/components/ecommerce/Loader'),
    { ssr: false }
  ),
};

export default pageModules;
